/*=========================================================================================
  File Name: globalComponents.js
  Description: Here you can register components globally
==========================================================================================*/
import MsButton from '@/components/button/MsButton.vue';
import MsSplitButton from '@/components/button/MsSplitButton.vue';
import MsDropDownButton from '@/components/button/MsDropDownButton.vue';
import MsInput from '@/components/input/MsInput.vue';
import MsCheckbox from '@/components/checkbox/MsCheckbox.vue';
import MsRadio from '@/components/radio/MsRadio.vue';
import MsDatepicker from '@/components/datepicker/MsDatePicker.vue';
import MsColorPicker from '@/components/colorpicker/MsColorPicker.vue'
import MsTextarea from '@/components/textarea/MsTextarea.vue';
// import VTooltip from "@/components/tooltip";
import MsNumber from '@/components/number/MsNumber.vue';
import MsCombobox from '@/components/combobox/MsCombobox.vue';
import MsComboboxEnum from '@/components/combobox/MsComboboxEnum';
import MsDynamicPopup from '@/components/popup/MsDynamicPopup.vue';
import MsPopoverGlobal from '@/components/popover/MsPopoverGlobal.vue';
import DisplayUser from '@/components/display-users/DisplayUsers.vue';
import MsGridViewer from '@/components/gridViewer/MsGridViewer.vue';

import vClickOutSide from 'click-outside-vue3';
export function useComponents(app) {
  app.component(MsButton.name, MsButton);
  app.component(MsSplitButton.name, MsSplitButton);
  app.component(MsDropDownButton.name, MsDropDownButton);
  app.component(MsInput.name, MsInput);
  app.component(MsCheckbox.name, MsCheckbox);
  app.component(MsRadio.name, MsRadio);
  app.component(MsDatepicker.name, MsDatepicker);
  app.component(MsColorPicker.name, MsColorPicker);
  app.component(MsTextarea.name, MsTextarea);
  // app.use(VTooltip);
  app.use(vClickOutSide);
  app.component(MsNumber.name, MsNumber);
  app.component('MsCombobox', MsCombobox);
  app.component(MsComboboxEnum.name, MsComboboxEnum);
  app.component(MsDynamicPopup.name, MsDynamicPopup);
  app.component(MsPopoverGlobal.name, MsPopoverGlobal);
  app.component(MsGridViewer.name, MsGridViewer);
  // app.component('DisplayUser', DisplayUser);
}
